import axios from 'axios'
import qs from 'qs'
import { Message } from 'view-design'
import { ERR_CODE_CUSTOM } from '@/utils/errCodeMap'

// formdata 对象
function paramsToFormData (obj) {
  const formData = new FormData()
  Object.keys(obj).forEach((key) => {
    if (obj[key] instanceof Array) {
      const trans_string = JSON.stringify(obj[key])
      formData.append(key, trans_string)
      return
    }
    formData.append(key, obj[key])
  })
  return formData
}

const service = axios.create({
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    const { url, method, data } = config
    if(method === 'post' && data) {
       if(url.includes('/puser') || url.includes('/pcap')){
        config.data = qs.stringify(data)
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
       }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if ((res.code && res.code !== '200') || (res.retcode && res.retcode !== '200')) {
      const url = response.config.url
      const errCode = res.code || res.retcode // 错误码
      const errList = ERR_CODE_CUSTOM[url] || {} // 根据url获取错误列表
      let err_msg = errList[errCode] || res.msg || res.retmsg ||'未知错误'
      Message.error({
        content: err_msg,
        duration: 3 //单位秒
      })
      return Promise.reject(res)
    } else { // code为 200
      return res
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js